import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { GlobalHeroComponent } from '../../shared/components/global-hero/global-hero.component';
import { JumpToComponent } from '../../shared/components/jump-to/jump-to.component';
import { Section1Component } from './section1/section1.component';
import { Section2Component } from './section2/section2.component';
import { CalloutComponent } from '../../shared/components/callout/callout.component';
import { Section3Component } from './section3/section3.component';
import { Section4Component } from './section4/section4.component';
import { CommonModule } from '@angular/common';
import { ScrollSpyService } from '../../shared/services/scroll-spy.service';
import { Observable } from 'rxjs';
import { appPaths } from '../../app.paths';
import { NewVideoSectionComponent } from './new-video-section/new-video-section.component';
import { ReviewBarComponent } from '../../shared/components/review-bar/review-bar.component';

@Component({
  selector: '[the-benefits-of-knowing]',
  imports: [
    CommonModule,
    GlobalHeroComponent,
    JumpToComponent,
    Section1Component,
    NewVideoSectionComponent,
    Section2Component,
    CalloutComponent,
    Section3Component,
    Section4Component,
    ReviewBarComponent,
  ],
  templateUrl: './the-benefits-of-knowing.component.html',
  styleUrl: './the-benefits-of-knowing.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TheBenefitsOfKnowingComponent implements OnInit, OnDestroy {
  appPaths = appPaths;

  scrollSpyService = inject(ScrollSpyService);

  activeSection$!: Observable<string | null>;

  jumpToData = [
    {
      buttonLabel: 'Know your options',
      buttonUrl: '/' + appPaths.BENEFITSOFKNOWING,
      buttonFragment: 'know-your-options',
    },
    {
      buttonLabel: 'Learn the symptoms',
      buttonUrl: '/' + appPaths.BENEFITSOFKNOWING,
      buttonFragment: 'learn-the-symptoms',
    },
    {
      buttonLabel: 'Talk to the experts',
      buttonUrl: '/' + appPaths.BENEFITSOFKNOWING,
      buttonFragment: 'talk-to-the-experts',
    },
  ];

  heroData = {
    backgroundImageDesktop: 'hero-the-benefit-of-knowing',
    titleText: 'The benefit <br class="d-none d-lg-inline" /> of',
    titleColorText: 'knowing what\'s coming',
    bodyText:
      'Screening for type 1 diabetes gives you the power to make informed decisions about your health, and help reduce serious emergencies at diagnosis.',
    bodyTextDesktopWidth: 'w-about-t1d-screening',
    sillHouetteImage: 'hero-sillhouette-the-benefit-of-knowing',
    sillhouette: {
      mobile: {
        width: 293,
        top: 0,
        left: 48,
      },
      tablet: {
        width: 323,
        top: 0,
        left: 55,
      },
      desktop: {
        width: 606,
        height: 341,
        top: 1,
        left: 104,
      },
    },
    sillhouetteAlt:
      'A father holding up his son who is dressed as an astronaut',
    altText: 'Actor portrayal',
  };

  ngOnInit(): void {
    const sectionIds = this.jumpToData.map((item) => item.buttonFragment);
    this.scrollSpyService.initObserver(sectionIds);

    this.activeSection$ = this.scrollSpyService.activeSection$;
  }

  ngOnDestroy(): void {
    this.scrollSpyService.disconnectObserver();
  }
}
